const Video = (props) => <video {...props} />;

export default Video;
